import {AnimateInteraction} from "../interactions/animate_interaction";

export class ContextItem {
	name = ""
	icon = ""
	interaction = null;


	constructor(name, icon, interaction) {
		this.name = name;
		this.icon = icon;
		this.interaction = interaction;
	}

	getName() {
		return this.name;
	}
}

export class ContextWheel {

	domElement = null;
	playerEnt = null
	showing = true;

	//TODO these should be set per metaverse or per player?
	menuItems = [
		new ContextItem("Chicken Dance", "Dance_Chicken", new AnimateInteraction("Dance_Chicken")),
		new ContextItem("Gone Fishing", "Fishing", new AnimateInteraction("Dance_Fishing")),
		// new ContextItem("Thriller", "Thriller", new AnimateInteraction("Dance_Thriller")),
		new ContextItem("Wave", "Wave", new AnimateInteraction("Dance_Wave")),
		new ContextItem("YMCA", "YMCA", new AnimateInteraction("Dance_YMCA")),
		new ContextItem("Golf Swing", "Golf_Swing", new AnimateInteraction("Golf Swing")),
		new ContextItem("Joyful Jump", "Joyful_Jump", new AnimateInteraction("Joyful Jump")),
		new ContextItem("Waving", "Waving", new AnimateInteraction("Waving")),
	]

	constructor(domElement, playerEnt, interactions = []) {
		// console.log("ContextWheel.constructor", domElement, playerEnt, interactions)
		this.domElement = domElement;
		this.playerEnt = playerEnt;
		this.setupListeners()

		for (const i of interactions) {
			this.menuItems.push(i);
		}

		this.hideWheel()
	}

	setupListeners() {
		document.addEventListener('keydown', (e) => this.onKeyDown(e));
		document.addEventListener('keyup', (e) => this.onKeyUp(e));
	}

	destroy() {
		document.removeEventListener('keydown', (e) => this.onKeyDown(e));
		document.removeEventListener('keyup', (e) => this.onKeyUp(e));
	}

	onKeyDown(e) {
		if (e.key === "r" && !this.showing) {
			this.showWheel()
		}
	}

	onKeyUp(e) {
		if (e.key === "r" && this.showing) {
			this.hideWheel()
		}
	}

	items() {
		return this.menuItems
	}

	showWheel() {
		if (this.showing)
			return

		// console.log("Showing Context wheel")
		// this.domElement.style.display = "block";
		this.showing = true;
		this.domElement.querySelectorAll(".context-item").forEach(element => {
			// console.log("CTX: Binding element:", element)
			element.addEventListener('click', this.handleInteractionClick);
		})
	}

	hideWheel() {
		if (!this.showing)
			return

		// console.log("Hiding Context wheel")

		// this.domElement.style.display = "none";
		this.showing = false;
		this.domElement.querySelectorAll(".context-item").forEach(element => {
			// console.log("CTX: UnBinding element:", element)
			element.removeEventListener('click', this.handleInteractionClick);
		})
	}

	handleInteractionClick = (e) => {
		const menu = this.menuItems[e.target.dataset.slot];
		menu.interaction.interact(this.playerEnt);
	}
}